export const MUNEndpoints = {
  WEBHOOK: "api/webhook",
};

export const MDMEndpoints = {
  AC_SCHOOL: "/ac-schools",
  AC_STUDENTS: "/ac-students",
  AC_ACADEMIC_YEARS: "/ac-academic-years",
  VIVA_ACTIVITY_MASTERS: "/viva-activity-masters",
  SCHOOL_CONTACT_MAPPINGS: "/school-address-phone-email-mappings",
  CO_DISCOUNTS: "/co-discounts",
  FC_SAC_MASTERS: "/fc-sac-masters",
  FC_FEES_MASTERS: "/fc-fees-masters",
  AC_GRADES: "/ac-grades",
  VIVA_HOME_PAGE_MASTER: "/viva-home-page-masters",
  VIVA_ZONE_SCHOOL_MAPPING: "/viva-zone-school-mappings",
};

export const SELFBASEEndpoints = {
  // `/` at prefix of api will be given in env/url
  EVENTS: {
    BASE: "api/events",
    MAX_CAPACITY: "api/events/summer-camp/max-capacity",
  },
  HOMEPAGE: "api/homePage",
  MUN: {
    GET_MDM_DATA: "api/mun/get-mdm-data",
  },
};
